import AppDispatcher from 'application/AppDispatcher';
import object from 'utils/object';

const CLASS_CONSTATNTS = object.namespacedConsts({
  FACEBOOK_COMMENTS: {
    ACTIONS: {
      SCROLL_TO: true,
      LOAD: true,
      LOADED: true
    }
  }
});

let facebookCommentsActions = {

  TYPES: CLASS_CONSTATNTS.FACEBOOK_COMMENTS.ACTIONS,

  scrollToFacebookComments: (scrollingEventObject) => {
    AppDispatcher.dispatchAction.view({
      type: facebookCommentsActions.TYPES.SCROLL_TO, scrollingEventObject
    });
  },

  loadFacebookComments: (facebookConfig) => {
    AppDispatcher.dispatchAction.view({
      type: facebookCommentsActions.TYPES.LOAD, facebookConfig
    });
  },

  facebookCommentsLoaded: () => {
    AppDispatcher.dispatchAction.view({
      type: facebookCommentsActions.TYPES.LOADED
    });
  },
};

export default facebookCommentsActions;



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/facebookCommentsActions.js